import { create } from 'zustand'
import createCompanyPreferencesSlice, {
  CompanyPreferencesSlice,
} from './preferences/slice'
import { SharedSlice, createSharedSlice } from 'src/components/slice'

const useCompanySettingsStore = create<CompanyPreferencesSlice & SharedSlice>()(
  (...props) => ({
    ...createSharedSlice(...props),
    ...createCompanyPreferencesSlice(...props),
  })
)

export default useCompanySettingsStore
